import { render, staticRenderFns } from "./StaffSet.vue?vue&type=template&id=6b1ee125&scoped=true&"
import script from "./StaffSet.vue?vue&type=script&lang=js&"
export * from "./StaffSet.vue?vue&type=script&lang=js&"
import style0 from "./StaffSet.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StaffSet.vue?vue&type=style&index=1&id=6b1ee125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1ee125",
  null
  
)

export default component.exports